<template>
<!--   <ProgressHUD
        ref="progress"
        :display="false"
    /> -->

  <layout-main>
  
    <div id="page-content-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h4 class="page-header">Projects</h4>
                </div>
            </div>
          <div class="form-group">
              <label for="wasProducedPerMonth" class="sub-title">Add Monthly Report</label>               
          </div>

          <form class="" data-vv-scope="formMonthlyReport" v-if="sentReport==0">             
              <div class="col-lg-6 col-md-6">
                        <div class="form-group">
                            <div class="add-product add-project report">
                                <ul>
                                      <li>
                                        <div class="form-group">
                                            <label for="">Project</label>
                                            <span class="inp-block">
                                              <select
                                                  name="project" class="sel-prjs" v-validate="'required'"  v-model="report.project" data-vv-as="Project" :class="{'error-input': errors.has('formMonthlyReport.project')}"
                                                >
                                                  <option value="" disabled selected></option>
                                                  <option
                                                      v-for="(item, k) in projects"
                                                      :value="item._id"
                                                  >{{item.name}}</option>
                                              </select>
                                              <span v-if="errors.has('formMonthlyReport.project')" class="error">{{ errors.first('formMonthlyReport.project') }}</span>
                                            </span>
                                        </div>
                                      </li>        
                                      <li>
                                        <div class="form-group date-inst">
                                            <label>Report Month</label>
                                            <span class="inp-block">
                                                <input
                                                  class="form-control month"
                                                  type="number"
                                                  name="month"
                                                  v-model="month"
                                                  v-validate="'required|max:2|min_value:01|max_value:12'"                                                  
                                                  data-vv-as="Month"
                                                  placeholder="MM"
                                                  min="01"
                                                  max="12"
                                                  :class="{'error-input': errors.has('formMonthlyReport.month')}"
                                                > /                                                
                                                <select
                                                  name="Year"
                                                  v-model="year"
                                                  class="year"
                                                  v-validate="'required|max:4|min_value:1980'"
                                                  data-vv-as="Year"
                                                  :class="{'error-input': errors.has('formMonthlyReport.Year')}"
                                                >
                                                  <option value="" selected disabled >yyyy</option>
                                                  <option
                                                      v-for="item in years"
                                                      :value="item"
                                                  >{{item}}</option>
                                                </select>
                                                <br>
                                                <span v-if="errors.has('formMonthlyReport.month')" class="error">{{ errors.first('formMonthlyReport.month') }}</span>
                                                <span v-if="errors.has('formMonthlyReport.Year')" class="error">{{ errors.first('formMonthlyReport.Year') }}</span>
                                              </span>                                            
                                        </div>
                                      </li>

                                      <li>
                                        <div class="form-group" :class="{'error-input': errors.has('formMonthlyReport.wasProducedPerMonth')}">
                                          <label for="wasProducedPerMonth">Monthly Energy Prodcution</label>
                                          <span class="inp-block">
                                            <input type="text" name="wasProducedPerMonth" class="form-control" v-model="report.wasProducedPerMonth" v-validate="'required|numeric|min_value:0'" ref="wasProducedPerMonth" data-vv-as="Was produced per month (MWh)"> 
                                          </span>            
                                          <span v-if="errors.has('formMonthlyReport.wasProducedPerMonth')" class="error">{{ errors.first('formMonthlyReport.wasProducedPerMonth') }}</span>
                                        </div> 
                                      </li>  

                                      <li>
                                        <div class="form-group"  :class="{'error-input': errors.has('formMonthlyReport.Report')}">
                                            <label for="">Upload Report</label>
                                            <span class="inp-block">
                                              <input
                                                type="file"
                                                class="form-control-file"
                                                name="Report"
                                                @change="onFileReportChange"
                                                v-validate="'required'"
                                                ref="report"
                                                data-vv-as="Upload Report"
                                                accept=".jpg, .pdf"
                                                placeholder="Choose PDF or JPG file"
                                                :class="{'error-input': errors.has('formMonthlyReport.Report')}"
                                              >
                                              <span
                                                v-if="errors.has('formMonthlyReport.Report')"
                                                class="error"
                                              >The field 'Upload Report' is required.</span>
                                            </span>  
                                        </div>
                                      </li>
                                      <li>
                                        <button type="button" class="btn btn-report" @click="sendReport(); sentReport=1;">Save</button>
                                      </li>
                                    </ul>
                                  </div>  
                                </div>
                              </div>   
          </form>

           <div class="col-lg-12 col-md-12" v-else>
              <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <span class="sent-report">Project Report received, <br>Thank YOU!</span>               
                  </div>

                  <div class="form-group">
                    <label class="">You will get your GREEN Tokens, Carbon Credits and Green certificates as soon the uploaded document is approved.</label>
                  </div>

                  <div class="form-group">
                    <div class="link-report" v-on:click="sentReport=0;">Add another report</div>
                  </div>  
              </div>          
          </div>  


        </div>
      </div>
    </div>
  </div>

  </layout-main>
</template>

<style type="text/css">
    #exampleModalCenter.modal .modal-footer .btn-primary {
        padding: 8px 14px;
        background: #00b248;
        /*box-shadow: 0 3px 6px #d8d8d8;*/
        float: right;
        margin-left: 15px;
        transition: 0.3s;
        border: none;
        color: #fff;
    }
    #exampleModalCenter.modal .modal-title {
        width: auto;
        float: left;
    }
    #exampleModalCenter.modal .close {
        color: #00b248;
        opacity: 1;
        font-size: 50px;
        float: right;
        line-height: 20px;
    }
    #exampleModalCenter.modal .modal-body form .form-group {
        width: 48%;
        display: inline-block;
    }
    #exampleModalCenter.modal .modal-body form .form-group:first-child {width: 100%;}
    #exampleModalCenter.modal .input-field {
        padding-top: 13px;
        width: 48%;
        display: inline-block;
        margin-left: 3%;
    }
    .form-group.error-input {
      border: none;
    }
</style>
<script>
import { Toast, Api, Helper } from './../../../../services'
import LayoutMain from './../../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../../ProgressHUD/index.vue'

export default {
  name: "ProjectSendReport",
  components: {
    LayoutMain,
    ProgressHUD,  
  },
  data() {
    return ({
      report: {
        project: "",
        wasProducedPerMonth: "",
        report: [],
      },
      year: '',
      month: '',
      projects: [],
      sentReport: 0,
    })
  },
  computed: {  
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 1979}, (value, index) => 1980 + index)
    }
  },
  methods: {
    onFileReportChange(event) {
      var files = event.target.files || event.dataTransfer.files
      this.report.report = files
    },
    async sendReport() {
      try {
        const isValid = await this.$validator.validateAll("formMonthlyReport")
        if (!isValid) {
          Toast.error({
            toast: this.$toast,
            message: 'The entered data is not valid',
          })
          return
        }

        if (this.$parent.$refs.progress) {
          //this.$parent.$refs.progress.show()
        } else {
          //this.$parent.$parent.$refs.progress.show()
        }

        var newReport = {
          projectId: this.report.project,
          produced: this.report.wasProducedPerMonth,
          month: this.month,
          year: this.year,
          report: this.report.report
        }
        var response = await Api.sendMonthlyReportForExistingProjects(newReport)
      
        Toast.success({
          toast: this.$toast,
          message: "Monthly report successfully saved",
        })
      } catch (error) {
        console.error(error)

        Toast.error({
          toast: this.$toast,
          message: error.message,
        })
      } finally {
        if (this.$parent.$refs.progress) {
          //this.$parent.$refs.progress.hide()
        } else {
          //this.$parent.$parent.$refs.progress.hide()
        }
      }
    }
  },
  mounted() {
    
  },
  async created() {
    try {
      var response = await Api.getProjectsByUserId()
      console.log("+++++++++++++++++++ response +++++++++++++")
      //console.log(response.data.projects[0])
      //this.projects = response.data

      response.data.projects.forEach(item => {

        this.projects.push(item)
      })

      console.log(this.projects)
    } catch (error) {
      this.validationMessage = 'Something went wrong.'

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: 'Something went wrong.',
      })

      console.error(error)
    } finally {
      //this.$refs.progress.hide()
    }  
  }  
}
</script>



// WEBPACK FOOTER //
// src/components/Account/MyProfile/Widget/ProjectSendReport.vue